// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Quote__text___IoaSh {
    font-family: "IM Fell French Canon SC";
    font-style: italic;
    font-size: 12px;
    margin: 5px;
    color: gold;
    text-shadow: 0px 0px 10px gold;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `Quote__text___IoaSh`
};
module.exports = ___CSS_LOADER_EXPORT___;
